export const COLORS = {
    primary: '#CCD5AE',
    secondary: '#FEFAE0',
    tertiary: '#D4A373',
    quaternary: '#E9EDC9',
    quinary : '#FAEDCD',
    lightText: '#fff',
    darkText: '#000',
    green: '#99AB5F'
  };